import React, { useEffect } from 'react'
import LinkTwoToneIcon from '@mui/icons-material/LinkTwoTone';
import HistoryTwoToneIcon from '@mui/icons-material/HistoryTwoTone';
import { ProSidebar, Menu, MenuItem, SidebarContent, SidebarHeader } from "react-pro-sidebar";
import { useAppDispatch, useAppSelector } from '../useStore';
import { getallapplicant } from '../features/Applicant/applicantSlice';


const InterviewSideBar = (Props: any, setActive: unknown,) => {

 const dispatch = useAppDispatch();
 const [actives, setActives] = React.useState("/activeinterview")
 const { data } = useAppSelector((state: any) => state.applicant);

 useEffect(() => {
  dispatch(getallapplicant());
 }, [dispatch]);


 useEffect(() => {
  Props.setActive(actives)
 }, [Props, actives, setActive])

 const interview = data?.data?.filter((obj: any) => {
  return obj?.InterviewLog?.interviewStatus === "PENDING"
 });
 const interviewComplete = data?.data?.filter((obj: any) => {
  return obj?.InterviewLog?.interviewStatus === "COMPLETED";
 });




 const sidebarList = [
  {
   title: "Active",
   icon: <LinkTwoToneIcon />,
   metric: !interview?.length ? "0" : interview?.length,
   path: "/activeinterview",
  },
  {
   title: "Interview History",
   icon: <HistoryTwoToneIcon />,
   metric: !interviewComplete?.length ? "0" : interviewComplete?.length,
   path: "/interviewhistory",
  },
 ];



 return (
  <div id='Sidenavbar'>
   <div id='SideBar__container'>

    <div className='SideBar__content'>
     <ProSidebar >
      <SidebarHeader><h4>Interview</h4></SidebarHeader>
      <SidebarContent>
       <Menu>
        {sidebarList.map((item, i) => (
         <MenuItem
          key={i}
          className='Side__Content'
          active={item.path === actives}
          icon={item.icon}
          suffix={item.metric}
          onClick={() => setActives(item.path)}>
          {item.title}
         </MenuItem>
        ))}
       </Menu>
      </SidebarContent>
     </ProSidebar>
    </div>
   </div>
  </div >
 )
}
export default InterviewSideBar

